// BLE lamp node (DeviceID 100) on the DESKTOP — the same panel as the phone
// (ui/shared/ble/BleNodePanel.jsx), in remote-only mode.
//
// A browser has no Bluetooth, so a Telink (Bluetooth Mesh) group is controlled
// through the location's HUB — an ESP32BLEGATEWAY on Wi-Fi + Bluetooth
// (docs/20): all on/off, brightness, colour, blink, each lamp's real state.
// With no hub at the location, or for a LampSmart group (advertising, no hub
// support yet), the panel says to use the phone instead.
//
// The MessageDialogProvider is here because the desktop shell does not mount
// one; without it the panel's errors and confirmations would vanish silently.

import React from 'react';
import DeviceShell from '../../components/DeviceShell';
import BleNodePanel from '../../../shared/ble/BleNodePanel';
import { MessageDialogProvider } from '../../../shared/MessageDialog';

export default function BleNodePage({ device }) {
  return (
    <DeviceShell title={device.DeviceName || device.UniqueNumber}>
      <MessageDialogProvider>
        <BleNodePanel device={device} remoteOnly />
      </MessageDialogProvider>
    </DeviceShell>
  );
}
